import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useSidebar } from '../context/SidebarContext';

const SidebarToggle = ({ isSidebarOpen, toggleSidebar }) => {
  const { isSidebarOpen: contextSidebarOpen, toggleSidebar: contextToggleSidebar } = useSidebar();
  const sidebarState = isSidebarOpen ?? contextSidebarOpen;
  const toggleFunction = toggleSidebar ?? contextToggleSidebar;

  // Only show when sidebar is closed
  if (sidebarState) {
    return null;
  }

  return (
    <div
      onClick={toggleFunction}
      style={{ height: "100%", width: "20px" }}
      className="fixed top-0 left-0 z-10 sidebar-toggle-hover transition-all duration-200 cursor-pointer"
    >
      <div
        style={{ height: "100%", width: "15px", marginLeft: "-4px" }}
        className="bg-transparent hover:bg-white p-1 transition-all duration-200"
      >
        <button className="flex items-center justify-center h-full text-transparent hover:text-black transition-all duration-200 - font-bold">
          <div className='flex items-center justify-center'>
            <ChevronRight className='font-bold' size={16} />
            <ChevronRight style={{ marginLeft: "-12px" }} className=' font-bold' size={16} />
          </div>
        </button>
      </div>
    </div>
  );
};

export default SidebarToggle;